import { cn } from '@/lib/utils'

interface ConfidenceBadgeProps {
  confidence: 'exact' | 'approximate'
}

export function ConfidenceBadge({ confidence }: ConfidenceBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center rounded-full px-2.5 py-0.5 text-xs font-bold leading-none border',
        confidence === 'exact'
          ? 'bg-green-50 text-green-700 border-green-200'
          : 'bg-amber-50 text-amber-700 border-amber-200',
      )}
    >
      {confidence === 'exact' ? 'Exact match' : 'Approximate match'}
    </span>
  )
}
